/**
 * Agent finance UI: hide synthetic system-balance ledger lines from selectable lists.
 * possibleProfit from /getBasicFinancials already includes these amounts (wallet SSOT).
 */

const SYSTEM_BOOKING = "SYSTEM";
const SYSTEM_BLOCK_REASON = "system_balance_not_withdrawable";

function normBookingRef(value) {
  return String(value ?? "")
    .trim()
    .toUpperCase();
}

function isSystemBalanceKind(value) {
  return String(value ?? "")
    .trim()
    .toLowerCase() === "system_balance";
}

/**
 * Raw row from /availableOrdersCommission bucket (gimmonix / lds / dynamic / manual).
 */
export function isFinanceAgentHiddenSystemBalanceRow(row) {
  if (row == null || typeof row !== "object") {
    return false;
  }
  if (row.is_system_balance === true) {
    return true;
  }
  if (String(row.withdrawal_block_reason ?? "").trim() === SYSTEM_BLOCK_REASON) {
    return true;
  }
  const refFields = [
    row.booking_ref,
    row.bookingReference,
    row.wallet_record_id,
    row.public_checkout_draft_id,
    row.commission_wallet_record_ref,
  ];
  for (const f of refFields) {
    if (normBookingRef(f) === SYSTEM_BOOKING) {
      return true;
    }
  }
  const meta = row.meta && typeof row.meta === "object" ? row.meta : null;
  if (meta && isSystemBalanceKind(meta.wallet_kind)) {
    return true;
  }
  if (isSystemBalanceKind(row.wallet_kind)) {
    return true;
  }
  if (isSystemBalanceKind(row.type) || isSystemBalanceKind(row.source)) {
    return true;
  }
  if (isSystemBalanceKind(row.source_type)) {
    return true;
  }
  return false;
}

export function filterFinanceAvailableRowsRemovingSystem(rawLines) {
  const kept = [];
  const removed = [];
  for (const row of Array.isArray(rawLines) ? rawLines : []) {
    if (isFinanceAgentHiddenSystemBalanceRow(row)) {
      removed.push(row);
    } else {
      kept.push(row);
    }
  }
  return { kept, removed };
}

export function logFinanceSystemRowRenderFilter(removedRows) {
  if (typeof import.meta === "undefined" || !import.meta.env?.DEV) {
    return;
  }
  const removed_count = removedRows.length;
  const removed_rows = removedRows.map((r) => ({
    id: r?.id ?? r?.source_id ?? null,
    booking_ref:
      r?.booking_ref ??
      r?.bookingReference ??
      r?.wallet_record_id ??
      r?.public_checkout_draft_id ??
      r?.commission_wallet_record_ref ??
      null,
  }));
  try {
    console.info(
      "[FINANCE_SYSTEM_ROW_RENDER_FILTER]",
      JSON.stringify({ removed_count, removed_rows })
    );
  } catch {
    console.info("[FINANCE_SYSTEM_ROW_RENDER_FILTER]", { removed_count, removed_rows });
  }
}
